import { useRef, useState } from "react";
import { Sparkle, MagicWand } from "@phosphor-icons/react";
import { oracleMessages, pickNextIndex } from "@/data/funzone";

const DEFAULT_TEXT = "Deine Zukunft sieht … durchsichtig aus. 😉";

export const GlassOracleCard = () => {
  const [idx, setIdx] = useState(-1);
  const [consulting, setConsulting] = useState(false);
  const timer = useRef(null);

  const consult = () => {
    if (consulting) return;
    setConsulting(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setIdx((cur) => pickNextIndex(oracleMessages, cur));
      setConsulting(false);
    }, 700);
  };

  return (
    <div
      className="rounded-3xl bg-violet-50 border border-violet-100 shadow-sm p-6 md:p-8 flex flex-col items-center text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl"
      data-testid="oracle-card"
    >
      <div className="w-12 h-12 rounded-2xl bg-violet-100 text-violet-700 flex items-center justify-center">
        <MagicWand size={26} weight="duotone" />
      </div>
      <h3 className="mt-4 text-xl font-bold text-slate-900">Scheiben-Orakel</h3>
      <p className="mt-1 text-sm text-violet-700 font-medium">Die Zukunft ist klarer, als du denkst.</p>

      <div className={`relative mt-5 ${consulting ? "fz-oracle-active" : ""}`} aria-hidden="true">
        <svg viewBox="0 0 100 100" className="w-24">
          <circle cx="50" cy="44" r="32" fill="#ede9fe" stroke="#7c3aed" strokeWidth="3" />
          <circle cx="50" cy="44" r="32" fill="url(#fzBallShine)" />
          <path d="M32 40 Q50 34 68 40 L72 54 Q50 60 28 54 Z" fill="#ddd6fe" stroke="#8b5cf6" strokeWidth="2" strokeLinejoin="round" opacity="0.9" />
          <circle cx="38" cy="32" r="4" fill="white" opacity="0.8" />
          <path d="M30 78 Q50 70 70 78 L74 88 Q50 96 26 88 Z" fill="#7c3aed" />
          <defs>
            <radialGradient id="fzBallShine" cx="0.35" cy="0.3" r="0.9">
              <stop offset="0%" stopColor="white" stopOpacity="0.7" />
              <stop offset="60%" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
        {consulting && (
          <>
            <Sparkle size={16} weight="fill" className="absolute -top-1 -left-2 text-amber-400 fz-twinkle" />
            <Sparkle size={12} weight="fill" className="absolute top-4 -right-3 text-violet-400 fz-twinkle" />
            <Sparkle size={14} weight="fill" className="absolute bottom-6 -left-4 text-sky-400 fz-twinkle" />
          </>
        )}
      </div>

      <p key={idx} className="fz-fade-in mt-5 min-h-[4.5rem] flex items-center text-base md:text-lg font-semibold text-slate-800 leading-snug" data-testid="oracle-text" aria-live="polite">
        {consulting ? "Das Orakel schaut nach …" : idx === -1 ? `„${DEFAULT_TEXT}"` : `„${oracleMessages[idx]}"`}
      </p>

      <button onClick={consult} disabled={consulting} className="mt-auto pt-5 w-full" data-testid="oracle-button">
        <span className="inline-flex items-center justify-center gap-2 w-full h-12 rounded-xl bg-violet-600 hover:bg-violet-700 active:scale-[0.98] text-white font-semibold transition-[background-color,transform] duration-200 focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 disabled:opacity-70">
          <span aria-hidden="true">🔮</span>
          Orakel befragen
        </span>
      </button>
    </div>
  );
};
